import React from "react";
import FILTVChannelChip from "./FILTVChannelChip";

export default function FILTVChannelStrip({ channels, activeLcn, onSelect, onMore }) {
    return (
        <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
            {channels.map((channel) => (
                <FILTVChannelChip
                    key={channel.lcn}
                    channel={channel}
                    active={channel.lcn === activeLcn}
                    onClick={() => onSelect(channel)}
                />
            ))}

            <button
                onClick={onMore}
                className="flex flex-col items-center justify-center min-w-[64px] rounded-xl bg-zinc-900 border border-dashed border-zinc-700 text-zinc-300 hover:border-purple-400 hover:text-purple-300 transition-colors"
            >
                <span className="text-lg leading-none">➕</span>
                <span className="text-[10px] mt-1">More</span>
            </button>
        </div>
    );
}
